<template>
  <div class="flex flex-col h-screen font-roboto">
    <Header />
    <div class="mt-40 mb-20 w-container lg:w-container-lg md:w-full md:px-5 mx-auto md:mt-36">
      <slot></slot>  
    </div>
    <div class="flex-grow"></div>
    <Footer/>
    <CookieBanner />
  </div>
</template>
<style>

</style>
